import classNames from "classnames";
import useBreakpoints from "hooks/useBreakpoints";
import { FreeMode, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import { LearnMoreItem } from "../../items";
import { Card } from "../Card";
import { CarouselStyled } from "./styles";

interface CarouselProps {
	items: LearnMoreItem[];
}

export const Carousel = ({ items }: CarouselProps) => {
	const { isSmDown } = useBreakpoints();

	return (
		<CarouselStyled className={classNames([isSmDown && "mobile"])}>
			<Swiper
				slidesPerView={1.2}
				spaceBetween={0}
				freeMode={false}
				modules={[FreeMode, Pagination]}
				className="mySwiper"
			>
				{items.map((card, index) => (
					<SwiperSlide key={index}>
						<Card item={card} />
					</SwiperSlide>
				))}
			</Swiper>
		</CarouselStyled>
	);
};
